import { __ } from '../../../../i18n';

export function getContractType() {
  return [
    { text: __('Principal'), value: 'INTEGRATION' },
    { text: __('Additional'), value: 'ADDITIONAL' },
  ];
}
